import _extends from "@babel/runtime/helpers/esm/extends";
import PropTypes from 'prop-types';
import React, { forwardRef, useContext } from 'react';
import { FormFieldContext } from '../FormField/FormField.context';
import { StyledFormHelp } from './FormHelp.styles';

/**
 * @related ['FieldSet', 'FormField']
 * @since 4.0.0
 */

export var FormHelp = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var _useContext = useContext(FormFieldContext),
    descriptionId = _useContext.descriptionId,
    error = _useContext.error;
  return /*#__PURE__*/React.createElement(StyledFormHelp, _extends({
    ref: forwardedRef,
    id: descriptionId || undefined,
    error: error
  }, props));
});
FormHelp.displayName = 'FormHelp';
FormHelp.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Displays the form help in an error state. Usually inherited from a FormField or
   * FieldSet parent.
   */
  error: PropTypes.bool
} : {};